import { render, staticRenderFns } from "./formSimpleCheckbox.vue?vue&type=template&id=60a656fa&"
import script from "./formSimpleCheckbox.vue?vue&type=script&lang=js&"
export * from "./formSimpleCheckbox.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports